import { request } from "../api";

export const serviceReportCompletadas = async ({ startDate, endDate, yardId, token }) => {
    const data = await request(`/reports/RoundsCompletionVm?StartDate=${startDate}&EndDate=${endDate}&YardId=${yardId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
    return data.value
}

export const servicioReporteTiempoXPuntosControl = async ({ startDate, endDate, yardId, token }) => {
    const data = await request(`/reports/avg-time-per-controlpoint?StartDate=${startDate}&EndDate=${endDate}&YardId=${yardId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
    return data
}

export const servicoReporteIncidenciasTipoNivel = async ({ startDate, endDate, yardId, token }) => {
    const data = await request(`/reports/incidents-by-type-level?StartDate=${startDate}&EndDate=${endDate}&YardId=${yardId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
    return data.value
}